// @ts-nocheck
import PropTypes from "prop-types";
import iconJSON from "./icons.json";

/*
 * focusable="false" is preventing SVG from gaining focus with tabs in IE11
 * https://stackoverflow.com/questions/29393144/how-to-prevent-svg-elements-from-gaining-focus-with-tabs-in-ie11
 * */

const Icon = ({ title, elements, ...rest }) => {
  return (
    <svg role="img" focusable="false" aria-hidden="true" {...rest}>
      <title>{title}</title>
      {elements.map(Icon.renderElement)}
    </svg>
  );
};

Icon.renderElement = ({ tag: TagName, ...rest }, index) => (
  <TagName key={`${TagName}-${index}`} {...rest} />
);

Icon.ICONS = iconJSON;

Icon.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string.isRequired,
      d: PropTypes.string,
      fill: PropTypes.string,
    }),
  ).isRequired,
  title: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  viewBox: PropTypes.string,
};

Icon.defaultProps = {
  height: 24,
  width: 24,
  title: "",
  viewBox: "0 0 24 24",
};

export default Icon;
